import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
import { AccountService } from '../../../../../lib/src/public-api';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  isLegalAccepted = false;
  constructor(
    private router: Router,
    private accountService: AccountService,
    private location: Location) { }

  ngOnInit() {
  }

  homeClicked() {
    this.router.navigate(['/']);
  }
}
